import { useEffect } from 'react'

const DEFAULT_TITLE = 'QT Robot'

export const useDocumentTitle = (title?: string) => {
  useEffect(() => {
    if (title) {
      document.title = `QT Robot - ${title}`
    } else {
      document.title = DEFAULT_TITLE
    }
  }, [title])
}
